import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-menu-list-item',
  templateUrl: './menu-list-item.component.html',
  styleUrls: ['./menu-list-item.component.scss'],
})
export class MenuListItemComponent implements OnInit {
  @Input() recipe;
  @Input() mealIndex = 4;
  mealIcon: string[] = ['eg-icons_morning', 'eg-icons_late-morning', 'eg-icons_noon', 'eg-icons_after-noon', 'eg-icons_evening'];

  get imgUrl() {
    return (this.recipe) ?  this.recipe.img || this.recipe.img.landscape.url : '';
  }
  constructor( public translate: TranslateService ) { }

  ngOnInit() {}

}
